import { useEffect } from 'react';
import { Box, Checkbox, Stack, TableCell, TableRow, TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

import { FormInputNumberController } from '@/components';
import { IngredientWithAmount } from '@/core';
import { formatDecimal } from '@/core/helpers/priceCalculator';
import { styles } from '@/features/product/components/formula/EditableIngredient/styles.ts';

export const TableRowIngredient = ({
  ingredientWithAmount,
}: {
  ingredientWithAmount: IngredientWithAmount;
}) => {
  const { ingredient, amount } = ingredientWithAmount;
  const { setValue, getValues, watch } = useFormContext();

  const removedIngredients = watch('ingredientsToBeRemoved');
  const isChecked = removedIngredients?.includes(ingredient.id);
  const controllerAmount = `ingredientsToBeModified.${ingredient.id}.amount`;

  useEffect(() => {
    const initialValue = getValues(controllerAmount);
    if (initialValue === undefined) {
      setValue(controllerAmount, ingredientWithAmount.amount.toString());
    }
  }, [controllerAmount, getValues, ingredientWithAmount.amount, setValue]);

  useEffect(() => {
    const fieldValue = getValues(controllerAmount);
    if (isChecked) {
      setValue(controllerAmount, 0);
    } else if (fieldValue === 0) {
      setValue(controllerAmount, '');
    }
  }, [controllerAmount, getValues, isChecked, setValue]);

  return (
    <TableRow key={ingredientWithAmount.ingredient.id}>
      <TableCell align="center" sx={{ px: 1 }}>
        <Controller
          name={'ingredientsToBeRemoved'}
          render={({ field }) => {
            return (
              <Checkbox
                {...field}
                checked={isChecked}
                onChange={(e) => {
                  const newValue = e.target.checked
                    ? [...field.value, ingredient.id]
                    : field.value.filter((id: number) => id !== ingredient.id);
                  field.onChange(newValue);
                }}
                icon={<span className="material-icons">remove_circle_outline</span>}
                checkedIcon={<span className="material-icons">remove_circle</span>}
              />
            );
          }}
        />
      </TableCell>
      <TableCell align="left">{ingredient.name}</TableCell>
      <TableCell align="right">
        <TextField disabled value={formatDecimal(amount)} />
      </TableCell>
      <TableCell align="right" sx={styles.shrinkCell}>
        <Stack direction="row" gap={1} alignItems="center">
          <FormInputNumberController
            label={''}
            controllerName={controllerAmount}
            decimalPlaces={2}
            disabled={isChecked}
          />
          <Box width={'25px'}>{ingredient.unit}</Box>
        </Stack>
      </TableCell>
    </TableRow>
  );
};
